/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationServiceMaterialsAliases {
  FRAGMENT_MAT = 'fragment-mat',
  FRAGMENT_OUTSOURCED_SERVICES = 'fragment-outsourced-services',
  FRAGMENT_PROC = 'fragment-proc',
  FRAGMENT_SERVICES = 'fragment-services',
  LAYOUT_0 = 'layout-0',
  PANEL_0 = 'panel-0',
  TAB_CONTROL = 'tab-control',
  TAB_WITH_CONTENT_MAT = 'tab-with-content-mat',
  TAB_WITH_CONTENT_OUTSOURCED_SERVICES = 'tab-with-content-outsourced-services',
  TAB_WITH_CONTENT_PROC = 'tab-with-content-proc',
  TAB_WITH_CONTENT_SERVICES = 'tab-with-content-services',
}
export { AccreditationServiceMaterialsAliases };
